import axios from 'axios';
import {
  Container, Grid, Backdrop, CircularProgress, Typography, Radio, FormControl, RadioGroup,
  FormControlLabel, Checkbox, Button, TextField
} from '@material-ui/core';
import { Form } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import { getAPIUrl, isValidEmail, isValidPhone } from '../helpers/CommonHelper';

class PersonInfo extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      tnc: true,
      isLoading: false,
      disablepickup: false,
      disabledrop: false,
      sameAsPersonDetail: 'none',
    };
  }

  componentDidMount() {
    if (Object.keys(this.props.customer).length !== 0) {
      let disablepickup = false;
      let disabledrop = false;
      switch (this.props.customer.sameAsPersonDetail) {
        case 'pickup':
          disablepickup = true;
          break;
        case 'drop':
          disabledrop = true;
          break;
      }
      this.setState({
        personFirstName: this.props.customer.customerContactDetail.firstName,
        personLastName: this.props.customer.customerContactDetail.lastName,
        personEmail: this.props.customer.customerContactDetail.email,
        personPhone: this.props.customer.customerContactDetail.phone.substring(2),
        pickupFirstName: this.props.customer.pickupContactDetail.firstName,
        pickupLastName: this.props.customer.pickupContactDetail.lastName,
        pickupPhone: this.props.customer.pickupContactDetail.phone.substring(2),
        dropFirstName: this.props.customer.dropContactDetail.firstName,
        dropLastName: this.props.customer.dropContactDetail.lastName,
        dropPhone: this.props.customer.dropContactDetail.phone.substring(2),
        sameAsPersonDetail: this.props.customer.sameAsPersonDetail,
        disabledrop,
        disablepickup,
      });
    }
  }

  handleSubmit = () => {
    if (this.state.personFirstName == undefined
      || this.state.personLastName == undefined
      || this.state.personEmail == undefined
      || this.state.personPhone == undefined
      || this.state.pickupFirstName == undefined
      || this.state.pickupLastName == undefined
      || this.state.pickupPhone == undefined
      || this.state.dropFirstName == undefined
      || this.state.dropLastName == undefined
      || this.state.dropPhone == undefined
      || this.state.personFirstName === ''
      || this.state.personLastName === ''
      || this.state.personEmail === ''
      || this.state.personPhone === ''
      || this.state.pickupFirstName === ''
      || this.state.pickupLastName === ''
      || this.state.pickupPhone === ''
      || this.state.dropFirstName === ''
      || this.state.dropLastName === ''
      || this.state.dropPhone === ''
    ) {
      alert('One or more field is missing');
      return;
    }

    const pickupContactDetail = {
      firstName: this.state.pickupFirstName,
      lastName: this.state.pickupLastName,
      phone: `+1${this.state.pickupPhone}`,
    };

    const dropContactDetail = {
      firstName: this.state.dropFirstName,
      lastName: this.state.dropLastName,
      phone: `+1${this.state.dropPhone}`,
    };

    const customerContactDetail = {
      firstName: this.state.personFirstName,
      lastName: this.state.personLastName,
      email: this.state.personEmail,
      phone: `+1${this.state.personPhone}`,
    };

    if (!isValidEmail(customerContactDetail.email)) {
      alert('Email is invalid');
      return;
    }

    if (!isValidPhone(pickupContactDetail.phone) || !isValidPhone(dropContactDetail.phone)
      || !isValidPhone(customerContactDetail.phone)) {
      alert('Phone is Invalid');
      return;
    }

    this.setState({
      isLoading: true,
    });

    const promise = [];

    promise.push(new Promise((resolve, reject) => {
      axios.post(`${getAPIUrl()}/customer/register`, {
        pickupContactDetail,
        dropContactDetail,
        customerContactDetail,
      }, {
        timeout: 30000,
      }).then(() => {
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }));

    promise.push(new Promise((resolve, reject) => {
      axios.put(`${getAPIUrl()}/quote/${this.props.quote.quoteId}`, {
        pickupContactDetail,
        dropContactDetail,
      }).then(() => {
        resolve();
      }).catch((error) => {
        reject(error);
      });
    }));

    Promise.all(promise).then(() => {
      this.setState({
        isLoading: false,
      });
      this.props.addCustomer({
        custId: customerContactDetail.email,
        sameAsPersonDetail: this.state.sameAsPersonDetail,
        pickupContactDetail,
        dropContactDetail,
        customerContactDetail,
      });
      this.props.setActiveStep(2);
    }).catch((err) => {
      console.error(err);
      this.setState({
        isLoading: false,
      });
      alert('Something went wrong!!!');
    });
  }

  inputChanged = (value, key) => {
    this.setState({
      [key]: value,
    });

    const val = this.state.sameAsPersonDetail;

    if (val !== 'none') {
      this.setState({
        [`${val}FirstName`]: this.state.personFirstName,
        [`${val}LastName`]: this.state.personLastName,
        [`${val}Phone`]: this.state.personPhone,
      });
    }
  }

  handlePersonDetailChange = (event) => {
    const val = event.target.value;
    this.setState({
      sameAsPersonDetail: val,
      disabledrop: false,
      disablepickup: false,
      pickupFirstName: '',
      pickupLastName: '',
      pickupPhone: '',
      dropFirstName: '',
      dropLastName: '',
      dropPhone: '',
    });

    if (val !== 'none') {
      this.setState({
        [`${val}FirstName`]: this.state.personFirstName,
        [`${val}LastName`]: this.state.personLastName,
        [`${val}Phone`]: this.state.personPhone,
        [`disable${val}`]: true,
      });
    } else {
      this.setState({
        disabledrop: false,
        disablepickup: false,
      });
    }
  }

  handleTNCChange = () => {
    this.setState({
      tnc: !this.state.tnc,
    });
  }

  render() {
    return (
      <Container>
        <Grid container className="margin-top10" direction="row" justify="center" alignItems="flex-start">
          <Grid item xs={12} sm={8} md={8}>
            <Form>
              <Typography variant="h6" gutterBottom>
                Your contact details
              </Typography>
              <Form.Group>
                <TextField
                  type="text"
                  label="First name"
                  value={this.state.personFirstName}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 30 }}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'personFirstName')}
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  type="text"
                  label="Last name"
                  value={this.state.personLastName}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 30 }}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'personLastName')}
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  type="text"
                  label="Email Address"
                  value={this.state.personEmail}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 30 }}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'personEmail')}
                />
              </Form.Group>
              <Form.Group>
                <TextField
                  type="text"
                  label="Phone number"
                  shrink
                  value={this.state.personPhone}
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 10 }}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'personPhone')}
                />
              </Form.Group>
            </Form>
          </Grid>
        </Grid>
        <Grid container direction="row" justify="center" alignItems="flex-start">
          <Grid xs={12} sm={8} md={8} item>
            <Form>
              <Form.Group>
                <FormControl component="fieldset">
                  <RadioGroup row value={this.state.sameAsPersonDetail} aria-label="contact-detail" name="customized-radios" onChange={this.handlePersonDetailChange}>
                    <FormControlLabel value="none" control={<Radio />} label="I am the mediator" />
                    <FormControlLabel value="pickup" control={<Radio />} label="I am the sender" />
                    <FormControlLabel value="drop" control={<Radio />} label="I am the receiver" />
                  </RadioGroup>
                </FormControl>
              </Form.Group>
            </Form>
          </Grid>
        </Grid>
        <Grid container spacing={3} direction="row" justify="center" alignItems="flex-start">
          <Grid xs={12} sm={8} md={4} item>
            <Form>
              <Typography variant="h6" gutterBottom>
                Pickup Person contact details
              </Typography>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="First name"
                  value={this.state.pickupFirstName}
                  disabled={this.state.disablepickup}
                  maxLength={50}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'pickupFirstName')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Last name"
                  value={this.state.pickupLastName}
                  disabled={this.state.disablepickup}
                  maxLength={50}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'pickupLastName')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="tel"
                  placeholder="Phone number"
                  value={this.state.pickupPhone}
                  disabled={this.state.disablepickup}
                  maxLength={10}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'pickupPhone')}
                />
              </Form.Group>
            </Form>
          </Grid>
          <Grid xs={12} sm={8} md={4} item>
            <Form>
              <Typography variant="h6" gutterBottom>
                Drop Person contact details
              </Typography>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="First name"
                  value={this.state.dropFirstName}
                  disabled={this.state.disabledrop}
                  maxLength={50}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'dropFirstName')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Last name"
                  value={this.state.dropLastName}
                  disabled={this.state.disabledrop}
                  maxLength={50}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'dropLastName')}
                />
              </Form.Group>
              <Form.Group>
                <Form.Control
                  type="tel"
                  placeholder="Phone number"
                  value={this.state.dropPhone}
                  disabled={this.state.disabledrop}
                  maxLength={10}
                  required
                  onChange={(event) => this.inputChanged(event.target.value, 'dropPhone')}
                />
              </Form.Group>
            </Form>
          </Grid>
        </Grid>
        <Grid container className="margin-top10" direction="row" justify="center" alignItems="flex-start">
          <Grid item>
            <Checkbox
              checked={this.state.tnc}
              onChange={this.handleTNCChange}
              name="tnc"
            />
            <span>By Click Next, you agree with our <a href='https://xpresspac.com/terms-and-conditions/' target="_blank">Terms &amp; Conditions</a></span>
          </Grid>
        </Grid>
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container direction="row" justify="center" alignItems="flex-start" className="margin-top10" spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              onClick={() => this.props.setActiveStep(0)}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              disabled={!this.state.tnc}
              onClick={this.handleSubmit}
            >
              Next
            </Button>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default PersonInfo;
